export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/profileFill.412c1cfd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};